export const API_ENDPOINTS = {
  EVENTS: '/api/events',
  CALENDAR_EVENTS: '/api/calendar-events',
  COMPETITIONS: '/api/competitions',
  ONEPIECE_COMPETITIONS: '/api/onepiece-competitions',
  MAGIC_COMPETITIONS: '/api/magic-competitions',
  RIFTBOUND_COMPETITIONS: '/api/riftbound-competitions',
  LORCANA_COMPETITIONS: '/api/lorcana-competitions',
  FLESHANDBLOOD_COMPETITIONS: '/api/fleshandblood-competitions',
  AUTH: '/api/auth',
} as const;

export const EXTERNAL_LINKS = {
  ADD_EVENT_FORM: 'https://forms.gle/fmFwZb7ZDcrvNUvg9',
  GOOGLE_MAPS_BASE: 'https://www.google.com/maps/search/?api=1&query=',
  REPORT_EMAIL: 'info@cardrevive.com.au',
} as const;

export const BREAKPOINTS = {
  MOBILE: 768,
} as const;

export const COLORS = {
  PRIMARY: '#3788d8',
  PRIMARY_HOVER: '#2a6bbf',
  BORDER: '#000000',
  ERROR: '#dc3545',
  WARNING: '#ffc107',
} as const;

export const AU_STATE_OPTIONS = [
  { code: 'ALL', label: 'All States' },
  { code: 'ACT', label: 'Australian Capital Territory' },
  { code: 'NSW', label: 'New South Wales' },
  { code: 'NT', label: 'Northern Territory' },
  { code: 'QLD', label: 'Queensland' },
  { code: 'SA', label: 'South Australia' },
  { code: 'TAS', label: 'Tasmania' },
  { code: 'VIC', label: 'Victoria' },
  { code: 'WA', label: 'Western Australia' },
] as const;
